<h1 class="title-reduced">Mess-Profis Mieterportal</h1>
<h2 class="title-reduced">Anmeldung</h2>
<h1 class="title-main">Anmeldung</h1>

<form [formGroup]="loginForm" class="login-form" (ngSubmit)="onSubmit()">
  <div>
    <mat-form-field class="login-input">
      <input matInput placeholder="E-Mail" [formControl]="usernameControl">
      <mat-error *ngIf="usernameControl.hasError('required')">
        Bitte geben Sie eine E-Mail Adresse ein
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="login-input">
      <input autocomplete="off" matInput placeholder="Passwort" [formControl]="passwordControl"
             [type]="hidePassword ? 'password' : 'text'">
      <mat-error *ngIf="passwordControl.hasError('required')">
        Bitte geben Sie ein Passwort ein
      </mat-error>
      <mat-icon matSuffix
                (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
    </mat-form-field>
  </div>
  <div class="submit">
    <button mat-raised-button [disabled]="loading" class="login-button">
      <mat-spinner *ngIf="loading"></mat-spinner>
      <mat-icon [class.hidden]="loading">login</mat-icon>
      Anmelden
    </button>
  </div>
</form>

<div class="errors">
  <div *ngIf="errNotAuthorized">
    <mat-icon>perm_identity</mat-icon>
    Die Kombination aus Benutzername und Passwort ist nicht korrekt.
  </div>
  <div *ngIf="errFailure">
    <mat-icon>close</mat-icon>
    Es ist ein Fehler aufgetreten.
  </div>
  <div *ngIf="errNotActive">
    <mat-icon>close</mat-icon>
    Der Zugang ist noch nicht aktiv.
  </div>
  <div *ngIf="errNoMieter">
    <mat-icon>close</mat-icon>
    Ihrem Zugang sind zurzeit keine aktiven Mieter zugeordnet.
  </div>
  <div *ngIf="errDataCreation">
    <mat-icon>receipt_long</mat-icon>
    Beim Generieren Ihrer Verbrauchsdaten ist ein Fehler aufgetreten.
  </div>
</div>

<div class="forgot">
  <button
    mat-button [disabled]="loading" (click)="resetPassword()">
    <mat-icon [class.hidden]="loading">password</mat-icon>
    Zugang zurücksetzen
  </button>
  <mp-hint-tooltip text="Falls Sie Ihr Passwort vergessen haben oder Ihnen die Aktivierungs-Email nicht mehr vorliegt, können Sie hier Ihren Zugang zurücksetzen."></mp-hint-tooltip>
</div>
